import React, {
    useEffect,
    useState,
} from "react";

import AdminLayout from "./AdminLayout";

const AdminAlumni = () => {

    const [
        alumni,
        setAlumni,
    ] = useState([]);

    const [
        selectedAlumni,
        setSelectedAlumni,
    ] = useState(null);

    const [
        loading,
        setLoading,
    ] = useState(true);

    const [
        search,
        setSearch,
    ] = useState("");

    // FETCH
    const fetchAlumni =
        async () => {

            try {

                const res =
                    await fetch(
                        "https://stjosephweb.ilakshyaerp.in/api/alumni/all"
                    );

                const result =
                    await res.json();

                if (
                    result.success
                ) {

                    setAlumni(
                        result.alumni
                    );

                }

            } catch {

                alert(
                    "Failed to load alumni ❌"
                );

            } finally {

                setLoading(false);

            }
        };

    useEffect(() => {

        fetchAlumni();

    }, []);

    // APPROVE
    const approveAlumni =
        async (id) => {

            try {

                const res =
                    await fetch(
                        `https://stjosephweb.ilakshyaerp.in/api/alumni/approve/${id}`,
                        {
                            method:
                                "PUT",
                        }
                    );

                const data =
                    await res.json();

                alert(
                    data.message
                );

                fetchAlumni();

            } catch {

                alert(
                    "Approval failed ❌"
                );

            }
        };

    // REJECT
    const rejectAlumni =
        async (id) => {

            try {

                const res =
                    await fetch(
                        `https://stjosephweb.ilakshyaerp.in/api/alumni/reject/${id}`,
                        {
                            method:
                                "PUT",
                        }
                    );

                const data =
                    await res.json();

                alert(
                    data.message
                );

                fetchAlumni();

            } catch {

                alert(
                    "Reject failed ❌"
                );

            }
        };

    // DELETE
    const deleteAlumni =
        async (id) => {

            const confirmDelete =
                window.confirm(
                    "Delete Alumni ?"
                );

            if (
                !confirmDelete
            )
                return;

            try {

                const res =
                    await fetch(
                        `https://stjosephweb.ilakshyaerp.in/api/alumni/delete/${id}`,
                        {
                            method:
                                "PUT",
                        }
                    );

                const data =
                    await res.json();

                alert(
                    data.message
                );

                fetchAlumni();

            } catch {

                alert(
                    "Delete failed ❌"
                );

            }
        };

    // FILTER
    const filteredAlumni =
        alumni.filter(
            (item) =>
                item.fullName
                    .toLowerCase()
                    .includes(
                        search.toLowerCase()
                    ) ||

                item.registrationNo
                    .toLowerCase()
                    .includes(
                        search.toLowerCase()
                    )
        );

    return (

        <AdminLayout>

            <div className="notice-page">

                <div className="flex justify-between items-center mb-8 flex-wrap gap-4">

                    {/* TITLE */}
                    <div>

                        <h2 className="text-3xl font-bold text-[#072F5F]">

                            Alumni Management

                        </h2>

                        <p className="text-gray-500 mt-1">

                            Manage alumni registrations and comments

                        </p>

                    </div>

                    {/* BUTTON */}
                    <button
                        onClick={() =>
                            window.location.href =
                            "/admin/alumni-comments"
                        }
                        className="
        group
        relative
        overflow-hidden
        bg-gradient-to-r
        from-[#072F5F]
        to-[#0d4b97]
        hover:from-[#d89f12]
        hover:to-[#f2b71b]
        text-white
        font-semibold
        px-7
        py-4
        rounded-2xl
        shadow-lg
        transition-all
        duration-300
        hover:scale-105
        flex
        items-center
        gap-3
      "
                    >

                        {/* ICON */}
                        <span className="text-2xl">

                            💬

                        </span>

                        {/* TEXT */}
                        <span>

                            Manage Comments

                        </span>

                    </button>

                </div>

                {/* TABLE */}
                <div className="notice-table">

                    <h2>
                        All Alumni Data
                    </h2>

                    <div
                        style={{
                            overflowX:
                                "auto",
                        }}
                    >

                        <table>

                            <thead>

                                <tr>

                                    <th>
                                        Photo
                                    </th>

                                    <th>
                                        Name
                                    </th>

                                    <th>
                                        Registration
                                    </th>

                                    <th>
                                        Mobile
                                    </th>

                                    <th>
                                        Status
                                    </th>

                                    <th>
                                        Action
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                {
                                    loading ? (

                                        <tr>

                                            <td
                                                colSpan="6"
                                                style={{
                                                    textAlign:
                                                        "center",
                                                }}
                                            >

                                                Loading...

                                            </td>

                                        </tr>

                                    ) : filteredAlumni.length > 0 ? (

                                        filteredAlumni.map(
                                            (
                                                item
                                            ) => (

                                                <tr
                                                    key={
                                                        item.id
                                                    }
                                                >

                                                    {/* IMAGE */}
                                                    <td>

                                                        <img
                                                            src={`https://stjosephweb.ilakshyaerp.in/uploads/alumni/${item.image}`}
                                                            alt=""
                                                            width="80"
                                                            height="80"
                                                            style={{
                                                                objectFit:
                                                                    "cover",
                                                                borderRadius:
                                                                    "8px",
                                                            }}
                                                        />

                                                    </td>

                                                    {/* NAME */}
                                                    <td>

                                                        <strong>

                                                            {
                                                                item.fullName
                                                            }

                                                        </strong>

                                                        <br />

                                                        {
                                                            item.className
                                                        }

                                                    </td>

                                                    {/* REGISTRATION */}
                                                    <td>

                                                        {
                                                            item.registrationNo
                                                        }

                                                    </td>

                                                    {/* MOBILE */}
                                                    <td>

                                                        {
                                                            item.mobileNo
                                                        }

                                                    </td>

                                                    {/* STATUS */}
                                                    <td>

                                                        <span
                                                            className={`
                                                            px-4
                                                            py-2
                                                            rounded-full
                                                            text-white
                                                            text-sm
                                                            font-semibold

                                                            ${item.status ===
                                                                    "approved"
                                                                    ? "bg-green-600"
                                                                    : item.status ===
                                                                        "rejected"
                                                                        ? "bg-red-600"
                                                                        : "bg-yellow-500"
                                                                }
                                                          `}
                                                        >

                                                            {
                                                                item.status
                                                            }

                                                        </span>

                                                    </td>

                                                    {/* ACTION */}
                                                    <td>

                                                        <div
                                                            style={{
                                                                display:
                                                                    "flex",
                                                                gap: "10px",
                                                                flexWrap:
                                                                    "wrap",
                                                            }}
                                                        >

                                                            {/* VIEW */}
                                                            <button
                                                                style={{
                                                                    background:
                                                                        "#0B5DB7",
                                                                    color:
                                                                        "#fff",
                                                                    border:
                                                                        "none",
                                                                    padding:
                                                                        "8px 14px",
                                                                    cursor:
                                                                        "pointer",
                                                                    borderRadius:
                                                                        "5px",
                                                                }}
                                                                onClick={() =>
                                                                    setSelectedAlumni(
                                                                        item
                                                                    )
                                                                }
                                                            >
                                                                View
                                                            </button>

                                                            {/* APPROVE */}
                                                            <button
                                                                onClick={() =>
                                                                    approveAlumni(
                                                                        item.id
                                                                    )
                                                                }
                                                                className="
                                                                bg-green-600
                                                                hover:bg-green-700
                                                                text-white
                                                                px-4
                                                                py-2
                                                                rounded-lg
                                                              "
                                                            >
                                                                Approve
                                                            </button>

                                                            {/* REJECT */}
                                                            <button
                                                                onClick={() =>
                                                                    rejectAlumni(
                                                                        item.id
                                                                    )
                                                                }
                                                                className="
                                                                bg-yellow-500
                                                                hover:bg-yellow-600
                                                                text-white
                                                                px-4
                                                                py-2
                                                                rounded-lg
                                                              "
                                                            >
                                                                Reject
                                                            </button>

                                                            {/* DELETE */}
                                                            <button
                                                                className="delete-btn"
                                                                onClick={() =>
                                                                    deleteAlumni(
                                                                        item.id
                                                                    )
                                                                }
                                                            >
                                                                Delete
                                                            </button>

                                                        </div>

                                                    </td>

                                                </tr>
                                            )
                                        )

                                    ) : (

                                        <tr>

                                            <td
                                                colSpan="6"
                                                style={{
                                                    textAlign:
                                                        "center",
                                                }}
                                            >

                                                No Alumni Found

                                            </td>

                                        </tr>

                                    )
                                }

                            </tbody>

                        </table>

                    </div>

                </div>

                {/* MODAL */}
                {
                    selectedAlumni && (

                        <div className="fixed inset-0 bg-black/60 z-[9999] flex justify-center items-center p-4">

                            <div className="bg-white w-full max-w-5xl rounded-3xl overflow-hidden shadow-2xl max-h-[95vh] overflow-y-auto">

                                {/* TOP */}
                                <div className="bg-gradient-to-r from-[#072F5F] to-[#0B5DB7] px-8 py-5 flex justify-between items-center">

                                    <div>

                                        <h2 className="text-3xl font-bold text-white">

                                            Alumni Details

                                        </h2>

                                        <p className="text-blue-100 mt-1">

                                            Complete alumni information

                                        </p>

                                    </div>

                                    <button
                                        onClick={() =>
                                            setSelectedAlumni(null)
                                        }
                                        className="
                                        bg-red-500
                                        hover:bg-red-600
                                        text-white
                                        px-5
                                        py-2
                                        rounded-lg
                                      "
                                    >
                                        Close
                                    </button>

                                </div>

                                {/* BODY */}
                                <div className="grid grid-cols-1 lg:grid-cols-3">

                                    {/* LEFT */}
                                    <div className="bg-[#F5F7FB] p-8 flex flex-col items-center border-r">

                                        <img
                                            src={`https://stjosephweb.ilakshyaerp.in/uploads/alumni/${selectedAlumni.image}`}
                                            alt=""
                                            className="
                                            w-64
                                            h-72
                                            object-cover
                                            rounded-2xl
                                            shadow-xl
                                            border-4
                                            border-white
                                          "
                                        />

                                        <div className="mt-6 w-full bg-white rounded-2xl shadow-md p-5">

                                            <div className="flex justify-between border-b pb-3 mb-3">

                                                <span className="font-semibold text-gray-600">
                                                    Name
                                                </span>

                                                <span className="font-bold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.fullName
                                                    }
                                                </span>

                                            </div>

                                            <div className="flex justify-between border-b pb-3 mb-3">

                                                <span className="font-semibold text-gray-600">
                                                    Registration
                                                </span>

                                                <span className="font-bold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.registrationNo
                                                    }
                                                </span>

                                            </div>

                                            <div className="flex justify-between border-b pb-3 mb-3">

                                                <span className="font-semibold text-gray-600">
                                                    Class
                                                </span>

                                                <span className="font-bold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.className
                                                    }
                                                </span>

                                            </div>

                                            <div className="flex justify-between">

                                                <span className="font-semibold text-gray-600">
                                                    Status
                                                </span>

                                                <span className="font-bold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.status
                                                    }
                                                </span>

                                            </div>

                                        </div>

                                    </div>

                                    {/* RIGHT */}
                                    <div className="lg:col-span-2 p-8">

                                        <h3 className="text-2xl font-bold text-[#072F5F] mb-8 border-b pb-4">

                                            Personal Details

                                        </h3>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                            <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                                <p className="text-sm text-gray-500 mb-1">
                                                    Father Name
                                                </p>

                                                <h4 className="text-lg font-semibold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.fatherName
                                                    }
                                                </h4>

                                            </div>

                                            <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                                <p className="text-sm text-gray-500 mb-1">
                                                    Mother Name
                                                </p>

                                                <h4 className="text-lg font-semibold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.motherName
                                                    }
                                                </h4>

                                            </div>

                                            <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                                <p className="text-sm text-gray-500 mb-1">
                                                    Mobile
                                                </p>

                                                <h4 className="text-lg font-semibold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.mobileNo
                                                    }
                                                </h4>

                                            </div>

                                            <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                                <p className="text-sm text-gray-500 mb-1">
                                                    Email
                                                </p>

                                                <h4 className="text-lg font-semibold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.email
                                                    }
                                                </h4>

                                            </div>

                                            <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                                <p className="text-sm text-gray-500 mb-1">
                                                    City
                                                </p>

                                                <h4 className="text-lg font-semibold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.city
                                                    }
                                                </h4>

                                            </div>

                                            <div className="bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                                <p className="text-sm text-gray-500 mb-1">
                                                    State
                                                </p>

                                                <h4 className="text-lg font-semibold text-[#072F5F]">
                                                    {
                                                        selectedAlumni.state
                                                    }
                                                </h4>

                                            </div>

                                        </div>

                                        {/* ADDRESS */}
                                        <div className="mt-8 bg-[#F8FAFC] rounded-xl p-5 shadow-sm border">

                                            <p className="text-sm text-gray-500 mb-2">
                                                Address
                                            </p>

                                            <h4 className="text-lg font-semibold text-[#072F5F] leading-8">

                                                {
                                                    selectedAlumni.address
                                                }

                                            </h4>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                    )
                }

            </div>

        </AdminLayout>
    );
};

export default AdminAlumni;